"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Mon Jul 23 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converts attributes of {@link PurchasePriceRow purchase price row} object.
 *
 * @author RV
 */


var PurchasePriceRowConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PurchasePriceRowConverter, _DataObjectConverter_);

  function PurchasePriceRowConverter() {
    _classCallCheck(this, PurchasePriceRowConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PurchasePriceRowConverter).apply(this, arguments));
  }

  return PurchasePriceRowConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PurchasePriceRowConverter = PurchasePriceRowConverter;